import type {
    AtribuirBairrosModel,
    BairroAtendido,
    BairroDisponivel,
    CidadeView,
} from "../models/atribuirBairrosModel"

export enum AtribuirBairrosActionsTypes {
    CARREGAR_DADOS = "CARREGAR_DADOS",
    CARREGAR_CIDADES_ESTABELECIMENTO = "CARREGAR_CIDADES_ESTABELECIMENTO",
    CARREGAR_TODAS_CIDADES = "CARREGAR_TODAS_CIDADES",
    SELECIONAR_CIDADE = "SELECIONAR_CIDADE",
    TOGGLE_BAIRRO = "TOGGLE_BAIRRO",
    TOGGLE_TODOS = "TOGGLE_TODOS",
    ATUALIZAR_CAMPO_FORM = "ATUALIZAR_CAMPO_FORM",
    ATUALIZAR_BAIRRO_ATENDIDO = "ATUALIZAR_BAIRRO_ATENDIDO",
    REMOVER_BAIRRO_ATENDIDO = "REMOVER_BAIRRO_ATENDIDO",
    LIMPAR_SELECAO = "LIMPAR_SELECAO",
}

export type AtribuirBairrosActionModel =
    | {
          type: AtribuirBairrosActionsTypes.CARREGAR_DADOS
          payload: { atendidos: BairroAtendido[]; naoAtendidos: BairroDisponivel[] }
      }
    | {
          type: AtribuirBairrosActionsTypes.CARREGAR_CIDADES_ESTABELECIMENTO
          payload: CidadeView[]
      }
    | {
          type: AtribuirBairrosActionsTypes.CARREGAR_TODAS_CIDADES
          payload: CidadeView[]
      }
    | {
          type: AtribuirBairrosActionsTypes.SELECIONAR_CIDADE
          payload: number
      }
    | {
          type: AtribuirBairrosActionsTypes.TOGGLE_BAIRRO
          payload: number
      }
    | {
          type: AtribuirBairrosActionsTypes.TOGGLE_TODOS
          payload: boolean
      }
    | {
          type: AtribuirBairrosActionsTypes.ATUALIZAR_CAMPO_FORM
          payload: {
              campo: keyof Pick<
                  AtribuirBairrosModel,
                  "taxa" | "taxaNoturna" | "minimoEntregaGratis" | "taxaEntregador"
              >
              valor: string
          }
      }
    | {
          type: AtribuirBairrosActionsTypes.ATUALIZAR_BAIRRO_ATENDIDO
          payload: BairroAtendido
      }
    | {
          type: AtribuirBairrosActionsTypes.REMOVER_BAIRRO_ATENDIDO
          payload: number
      }
    | {
          type: AtribuirBairrosActionsTypes.LIMPAR_SELECAO
      }
